import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'

// Who has been editing, and how widely.
//
// One user correcting the course they play every week looks nothing like one user touching
// forty courses in an afternoon, and this table is what makes the difference visible without
// reading the feed. The two actions that matter live here for the same reason: by the time a
// pattern is recognisable, it is a user you want to undo and stop, not a single row.
const formatTime = (ms) => (ms ? new Date(ms).toLocaleString() : '')

export default function EditorsTable({ editors, onFilterAccount, onRevertAccount, onBlock, working }) {
  if (editors.length === 0) {
    return <p className="text-muted">Nobody has edited public course data in this window.</p>
  }

  return (
    <Table size="sm" responsive hover>
      <thead>
        <tr>
          <th>Who</th>
          <th>Edits</th>
          <th>Courses</th>
          <th>First</th>
          <th>Last</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {editors.map((editor) => (
          <tr key={editor.accountId} className={editor.blocked ? 'table-warning' : undefined}>
            <td>
              <Button
                variant="link"
                size="sm"
                className="p-0"
                onClick={() => onFilterAccount(editor.accountId)}
              >
                {editor.email || `account ${editor.accountId}`}
              </Button>
              {editor.blocked && (
                <>
                  {' '}
                  <Badge bg="danger" title={editor.blockedReason || ''}>
                    blocked
                  </Badge>
                </>
              )}
            </td>
            <td>{editor.editCount}</td>
            <td>{editor.courseCount}</td>
            <td className="text-nowrap small">{formatTime(editor.firstEdit)}</td>
            <td className="text-nowrap small">{formatTime(editor.lastEdit)}</td>
            <td className="text-nowrap">
              <Button
                size="sm"
                variant="outline-danger"
                className="me-2"
                disabled={working}
                onClick={() => onRevertAccount(editor.accountId)}
              >
                Revert all
              </Button>
              <Button
                size="sm"
                variant={editor.blocked ? 'outline-success' : 'outline-secondary'}
                disabled={working}
                onClick={() => onBlock(editor.accountId, !editor.blocked)}
              >
                {editor.blocked ? 'Unblock' : 'Block edits'}
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
